import { ClearRounded as ClearRoundedIcon } from '@mui/icons-material';
import { EditRounded as EditRoundedIcon }  from '@mui/icons-material';

interface Props {
    toggleEdit: boolean;
    onClick?: () => void;
}

export function ToggleEditButton({ toggleEdit, onClick }: Props) {
    return (
        <div
            className="hover:bg-gray-200 rounded-md w-[25px] h-[25px] flex justify-center items-center cursor-pointer"
            onClick={onClick} >
            {toggleEdit
            ? <ClearRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
            : <EditRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
            }
        </div>
    );
}
